export const SET_MIPIH = 'SET_MIPIH';
export const GET_MIPIH = 'GET_MIPIH';
export const SET_FRANCE_CONNECT_DATA = 'SET_FRANCE_CONNECT_DATA';
export const CLEAR_FRANCE_CONNECT_DATA = 'CLEAR_FRANCE_CONNECT_DATA';
export const SET_EDPV3_USER_MESSAGE = 'SET_EDPV3_USER_MESSAGE';



// WEBPACK FOOTER //
// ./src/store/modules/authentification/types.js